import './apiAuth'
/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import firebase from 'firebase/app';
import 'firebase/auth';
import './fake-db/index.js'
import './filters/filters'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(Vuesax)

var config = {
  apiKey: "AIzaSyClcxp3x2WpOwxQH_viCn5guyCGCQ07Ln8",
  authDomain: "xxmac-co.firebaseapp.com",
  databaseURL: "https://xxmac-co-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "xxmac-co",
  storageBucket: "xxmac-co.appspot.com",
  messagingSenderId: "1056559869284",
  appId: "1:1056559869284:web:4f7bf9b539c5d318545e71"
};
firebase.initializeApp(config)
// axios
import axios from "./axios.js"
Vue.prototype.$http = axios


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false
let app;
firebase.auth().onAuthStateChanged(()=>{
  if(!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
